module.exports = __webpack_public_path__ + "images/emoji/clock1130.8f9620588a41ecdba4cd.png";